module.exports = __webpack_public_path__ + "static/media/event_calendar.5ffd0c46.svg";